import React, { useEffect, useState } from 'react'
import { getTypeWatchDelay, HideLoder, ShowLoder, typewatch } from '../../JS/Common'
import { ApiGetCall } from '../../JS/Connector';
import Pagination from 'react-js-pagination';
import Tab from '../../Components/Tab';
import useConfig from '../../Hooks/useConfig';
import { set } from 'lodash';

export default function CurrentPurchases() {
    const { organization, adminCallNode, manager_name, manager_email } = useConfig();
    const [GridData, setGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Schools, setSchools] = useState([]);
    const [SchoolValue, setSchoolValue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [SortFlag, setSortFlag] = useState("desc");
    const [searchstring, setSearchstring] = useState("");
    const [sortbykey, setSortbykey] = useState("school");
    const [gridTabType, setGridTabType] = useState({
        current: "active",
        past: ""
    })
    const showPagination = GridData.length > 0;

    useEffect(() => {
        ApiGetCall("/schools/with-insurance-plans").then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                const sortedSchools = responseRs.msg.sort((a, b) =>
                    a.name.localeCompare(b.name)
                );
                setSchools(responseRs.msg.length ? sortedSchools : [])
                setLoading(false);
            }
        });
        AllCurrentPurchases(1, null, null, SortFlag, "school", false)
    }, []);

    useEffect(() => {
        AllCurrentPurchases(gridTabType.current == "active" ? 1 : 2, SchoolValue, searchstring, SortFlag, sortbykey, false);
    }, [currentPage, LimitForPagination]);

    async function AllCurrentPurchases(gridFlag, sclid, searchString, sortFlag, sortbykey, toogleSort) {
        if (searchString?.trim() == "") {
            searchString = null;
        } else {
            searchString = searchString?.trim() || null;
        };
        if (!sclid) sclid = null;
        if (toogleSort) sortFlag = sortFlag == "asc" ? "desc" : "asc";
        setSortbykey(sortbykey);
        setSearchstring(searchString);
        setSortFlag(sortFlag);
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`${adminCallNode}/plans/insurance/parental-purchases/all?flag=${gridFlag}&schoolId=${sclid}&sortBy=${sortbykey}&sortByOrder=${sortFlag}&search=${searchString}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    setGridData(responseRs?.enrollment?.data?.length ? responseRs.enrollment.data : [])
                    setpageRangeCount(responseRs?.enrollment?.total)
                }
            });
        }, getTypeWatchDelay(searchString, 500));
    }
    function FilterBySch(e) {
        if (e.target.value == 0) {
            AllCurrentPurchases(gridTabType.current == "active" ? 1 : 2, null, null, SortFlag, sortbykey, false);
        } else {
            AllCurrentPurchases(gridTabType.current == "active" ? 1 : 2, e.target.value, searchstring, SortFlag, sortbykey, false)
        }
    }

    function handleTabClick(tabType) {
        if (tabType == "current") {
            setGridTabType({ ...gridTabType, current: "active", past: "" });
            setCurrentPage(1);
            AllCurrentPurchases(1, null, null, "desc", "school", false);
        } else if (tabType == "past") {
            setGridTabType({ ...gridTabType, current: "", past: "active" });
            setCurrentPage(1);
            AllCurrentPurchases(2, null, null, "desc", "school", false);
        }
        setSchoolValue(0);
        setSearchstring("");
    }

    function handlesorting(column) {
        AllCurrentPurchases(gridTabType.current == "active" ? 1 : 2, SchoolValue, searchstring, SortFlag, column, true)
    }
    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className="row pe-0 align-items-center mb-2 me-0">
                <div className="col-md-4">
                    <h1 className="PageHeading">Current Purchases</h1>
                </div>
                <div className="col-md-3 row align-items-center">
                    <div className="px-1 col-md-8 text-end font-13">Items per page:</div>
                    <div className="col-md-4 px-0">
                        <select value={LimitForPagination} onChange={(e) => {
                            setLimitForPagination(e.target.value);
                            setCurrentPage(1);
                        }}>
                            {[25, 50, 100, 150, 200, 500, 1000].map(value => (
                                <option key={value} value={value}>{value}</option>
                            ))}
                        </select></div>
                </div>
                <div className='col-md-2 pe-0 text-end SearchBarDivforloner'>
                    <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
                        <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon"><i className="bi bi-search"></i></div>
                        <input className="form-control marginCss" autoComplete="off" type="text" placeholder="Search"
                            onKeyUp={(e) => { AllCurrentPurchases(gridTabType.current == "active" ? 1 : 2, SchoolValue, e.target.value, SortFlag, sortbykey, false) }}
                            onKeyDown={(e) =>
                                (["#", "?", "/", "\\"].includes(e.key) || (e.key == " " && !e.target.value)) &&
                                e.preventDefault()
                            } />
                    </form>
                </div>
                <div className="col-md-3 text-end pe-0">
                    <div className=" ms-2 py-1 pe-0">
                        <select value={SchoolValue} onChange={(e) => {
                            setSchoolValue(e.target.value == "0" ? null : e.target.value);
                            FilterBySch(e);
                        }}>
                            <option value="0">Filter by {organization}</option>
                            {Schools.map((item, j) => (
                                <option value={item.id} key={j}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <div className='GridBox p-3'>
                <div className="row align-items-center mb-3">
                    <div className="col-md-7 px-0">
                        <ul className="nav nav-tabs px-3">
                            <Tab isActive={gridTabType.current == 'active'}
                                label="Current Purchases" onClick={() => handleTabClick('current')} col={'col-md-4'} />
                            <Tab isActive={gridTabType.past == 'active'}
                                label="Past Purchases" onClick={() => handleTabClick('past')} col={'col-md-4'} />
                        </ul>
                    </div>
                </div>
                <div className='col-12 greyBox data-table-container'>
                    <table className="table data-table mb-0" >
                        <thead className='GridHeader'>
                            <tr>
                                <th scope="col" title={`Sort by ${organization} Name`} className="cursor-pointer" onClick={(e) => handlesorting("school")}>
                                    {organization} Name
                                    <img src="/images/sortbynew.svg" alt={`Sort by ${organization} Name`} className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" title={`Sort by Club Name`} className="cursor-pointer" onClick={(e) => handlesorting("planName")}>Club Name
                                    <img src="/images/sortbynew.svg" alt={`Sort by Club Name`} className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" title={"Sort by User ID"} className="cursor-pointer" onClick={(e) => handlesorting("studentNum")}>User ID
                                    <img src="/images/sortbynew.svg" alt={"Sort by User ID"} className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" title={`Sort by ${manager_name}`} className="cursor-pointer" onClick={(e) => handlesorting("parentName")}>{manager_name}
                                    <img src="/images/sortbynew.svg" alt={`Sort by ${manager_name}`} className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" title={`Sort by ${manager_email}`} className="cursor-pointer" onClick={(e) => handlesorting("parentemail")}>{manager_email}
                                    <img src="/images/sortbynew.svg" alt={`Sort by ${manager_email}`} className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col" title={`Sort by Price`} className="cursor-pointer" onClick={(e) => handlesorting("planPrice")}>Price
                                    <img src="/images/sortbynew.svg" alt={`Sort by Price`} className="img-fluid ps-2 sortbyClass" />
                                </th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {GridData.length != 0 ?
                                GridData.map((item, i) => {
                                    return <tr key={i} className={`OddEvenClass tableBorderHide`}>
                                        <td className='py-12'>{item.school || '-'}</td>
                                        <td className='py-12'>{item.plan_name || '-'}</td>
                                        <td className='py-12'>{item.student_num || '-'}</td>
                                        <td className='py-12'>{item.parent_name || '-'}</td>
                                        <td className='py-12'>{item.parent_email || '-'}</td>
                                        <td className='py-12'>{`$${item.plan_price}` || '$0'}</td>
                                        <td className='py-12'>{item.status == 1 ? 'Enrolled' :
                                            item.status == 2 ? "Not Enrolled" :
                                                item.status == 3 ? "Refunded" : "-"}</td>
                                    </tr>
                                })
                                :
                                <tr>
                                    <td colSpan={18} className="p-3 text-center">
                                        No Record Found
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                {showPagination && (
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        itemsCountPerPage={LimitForPagination}
                        onChange={(e) => {
                            setCurrentPage(e);
                        }}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                )}
            </div >
        </>
    )
}
